import { Avatar, Box, Rating, SxProps, Typography } from "@mui/material";

import { useEffect, useState } from "react";
import {IImage} from "@/services/api/Image/types";
import imagesApi from "@/services/api/Image";
import {IRating} from "@/services/api/Rating/types";

interface ServiceRatingListItemProps {
  rating: IRating;
}

const ServiceRatingListItem = (props: ServiceRatingListItemProps) => {
  const { rating } = props;
  const [userImage, setUserImage] = useState<IImage | null>(null);

  useEffect(() => {
    imagesApi.findByUserId(rating.User.id).then(setUserImage);
  }, [rating.User.id]);

  return (
      <Box sx={styles.container}>
        <Box sx={styles.mainInfo}>
          <Avatar src={userImage?.thumbnailUrl} />
          <Box>
            <Typography>{rating.User.name}</Typography>
            <Rating value={rating.rating} readOnly />
          </Box>
        </Box>
        <Box>
          <Typography>{rating.comment}</Typography>
        </Box>
      </Box>
  );
};

export default ServiceRatingListItem;

const styles = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  } as SxProps,

  mainInfo: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  } as SxProps,
};
